<template>
    <div class="sale_des">
      <div class="tit">担保交易说明</div>
      <p>卖家只需在官方交易平台上发布担保出售信息，设置口令，然后给到指定买家进行购买，购买后联系客服进行发货</p>
      <van-button class="know" round color="var(--theme)" @click="close">我已知晓</van-button>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
      }
    },
    computed: {},
    created () {},
    mounted () {},
    methods: {
      close() {
          this.$emit('closeModal')
      }
    },
    watch: {},
  }
  </script>
  
  <style lang="less" scoped>
  .sale_des {
      z-index: 100000;
      padding: 2.4rem 2.6rem;
      background-color: #fff;
      .tit {
          text-align: center;
          font-size: 1.6rem;
          font-weight: 700;
          color: #fe6455;
          margin-bottom: 2rem;
      }
      p {
          font-size: 1.4rem;
          color: #555;
          line-height: 1.5;
          margin-bottom: 2.2rem;
      }
      .know {
          width: 100%;
          height: 3.2rem;
          font-size: 1.6rem;
      }
  }
  </style>
  